module.exports = __webpack_public_path__ + "img/scanner_de_seguridad.78d95aa5.jpg";